"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "21", height: "21", viewBox: "0 0 21 21", className: "Icon nav-search", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M19.243 19.242a1.005 1.005 0 0 1-1.419-.004l-4.067-4.067a8.565 8.565 0 0 0 1.414-1.415l4.067 4.068a.992.992 0 0 1 .005 1.418M1 8.499c0-4.135 3.364-7.5 7.5-7.5s7.5 3.365 7.5 7.5c0 4.136-3.364 7.5-7.5 7.5S1 12.635 1 8.499m14.749 4.422A8.451 8.451 0 0 0 17 8.5 8.5 8.5 0 0 0 8.5 0 8.5 8.5 0 0 0 0 8.5 8.5 8.5 0 0 0 8.5 17a8.446 8.446 0 0 0 4.421-1.251l4.196 4.196a2.003 2.003 0 0 0 2.833.004 1.997 1.997 0 0 0-.005-2.832l-4.196-4.196z", fill: "#929292", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/nav-search.js
// module id = 1820
// module chunks = 0